import { Box, Divider } from '@mui/material';
import { Footer } from 'src/web-ui/components/Footer';
import { makeStyles } from 'tss-react/mui';
import { PageContainerHeader } from './PageContainerHeader';

const useStyles = makeStyles()((theme) => ({
  container: {
    height: 'calc(100% - 56px)',
    overflow: 'auto',
  },
  main: {
    margin: '0 auto',
    width: '100%',
    maxWidth: 1200,
    padding: theme.spacing(1.5),
    minHeight: '100%',
  },
  footerContainer: {
    maxWidth: 1200,
    margin: '0 auto',
  },
}));

export const PageContainer = ({ children }: { children: React.ReactNode }) => {
  const { classes } = useStyles();

  return (
    <Box height="100%">
      <PageContainerHeader />
      <Box className={classes.container}>
        <Box className={classes.main}>
          <>{children}</>
          {/** WUT */}
        </Box>
        <Divider />
        <Box className={classes.footerContainer}>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};
